// Re-export auth service functions from the new auth system
export {
  isAuthenticated,
  getCurrentUser,
  getUserInfo,
  getToken,
  authSignOut,
  authSignIn,
  signInWithProvider,
  redirectToExternalAuth,
} from './amplify-service';

// Export stopImpersonation from NewAuthProvider
export type { AuthContextType } from './NewAuthProvider';

export const getGroupsFromAccessToken = (accessToken: { payload: Record<string, unknown> } | undefined): string[] => {
  return (accessToken?.payload['cognito:groups'] ?? []) as string[];
};

// Helper to extract groups from new auth system's user info
export const getGroupsFromUserInfo = (userInfo: { 'cognito:groups'?: string[] } | undefined): string[] => {
  return userInfo?.['cognito:groups'] ?? [];
};

// These functions are now handled by NewAuthProvider's useAuth hook
// Keeping for backward compatibility, but they're not needed anymore
